export default "__VITE_ASSET__BFz7$EIk__"